import { createStore, combineReducers } from 'redux'
import { runRootSaga } from 'common/modules/middleware/sagas'

import composeMiddleware from './middleware'
import globalReducers, { initialStates as globalInitialState } from './reducer'

let store = null

function storeFactory({
    reducers = {},
    initialStates = {},
    takes = [],
    middleware = [],
    modules = [],
}) {
    const moduleData = modules.reduce((acc, module) => {
        if (
            !module.store
            || !module.reducer
            || !module.initialState
        ) {
            /* eslint-disable-next-line no-console */
            console.warn('the module supplied to storeFactory was misconfigured')
            return acc
        }

        return {
            reducers: {
                ...acc.reducers,
                [module.store]: module.reducer,
            },
            initialStates: {
                ...acc.initialState,
                [module.store]: module.initialState,
            },
        }
    }, {
        reducers: {},
        initialStates: {},
    })

    const combinedReducers = combineReducers({
        ...globalReducers,
        ...moduleData.reducers,
        ...reducers,
    })

    const combinedInitialStates = {
        ...globalInitialState,
        ...moduleData.initialStates,
        ...initialStates,
    }

    const composedMiddleware = composeMiddleware({
        middleware,
    })

    if (store === null) {
        store = createStore(
            combinedReducers,
            combinedInitialStates,
            composedMiddleware,
        )
    }

    const sagaTakes = [
        ...modules.reduce((acc, reduxModule) => [
            ...acc,
            ...reduxModule.takes,
        ], []),
        ...takes.map((take) => take({ dispatch: store.dispatch, getState: store.getState })),
    ]

    const sagas = runRootSaga(sagaTakes)({ dispatch: store.dispatch, getState: store.getState })

    return {
        store,
        combinedReducers,
        sagas,
    }
}

export default storeFactory
